
interface ApiConfig {
  API: string;
}

interface CountryConfig {
  defaultDialCode: string;
  defaultCountryCode: string;
}

interface Config {
api: ApiConfig;
country: CountryConfig;
}

// Determine API URL - use relative path if proxied through nginx, otherwise use full URL
const getApiUrl = (): string => {
  // Priority 1: Check if we're on deployed domain - use relative path for nginx proxy
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname.includes('ecartdev.amanatfintech.com') || hostname.includes('ecartuat.amanatfintech.com')) {
      // Use relative path with /v1 - nginx will proxy to API
      // The API endpoints expect /v1/ prefix
      return '/api/v1';
    }
    if (hostname === 'ecart.amanatfintech.com' || hostname.includes('ecart.amanatfintech.com')) {
      // Production uses /newapi/v1 endpoint
      return '/newapi/v1';
    }
  }
  
  // Priority 2: Check if API_URL is set in environment (for local development or custom configs)
  const envApiUrl = process.env.REACT_APP_API_URL || process.env.REACT_APP_API;
  if (envApiUrl) {
    return envApiUrl;
  }
  
  // Priority 3: Check if we're in production
  if (process.env.NODE_ENV === 'production') {
    return 'https://prodapi.amanatfintech.com/newapi/v1';
  }
  
  // Priority 4: Fallback to full API URL for local development
  return 'https://devapi.amanatfintech.com/api/';
};

const config: Config = {
api: {
  API: getApiUrl(),
},
country: {
  defaultDialCode: process.env.REACT_APP_DIAL_CODE || process.env.REACT_APP_DEFAULT_DIAL_CODE || (process.env.NODE_ENV === 'production' ? '+973' : '+91'),
  defaultCountryCode: process.env.REACT_APP_COUNTRY_CODE || process.env.REACT_APP_DEFAULT_COUNTRY_CODE || (process.env.NODE_ENV === 'production' ? 'BH' : 'IN'),
},
};

export default config;

